import { render, staticRenderFns } from "./EVModelling.vue?vue&type=template&id=ddd057fe&scoped=true"
import script from "./EVModelling.vue?vue&type=script&lang=js"
export * from "./EVModelling.vue?vue&type=script&lang=js"
import style0 from "./EVModelling.vue?vue&type=style&index=0&id=ddd057fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd057fe",
  null
  
)

export default component.exports